import { render, staticRenderFns } from "./TransferStoreInformation.vue?vue&type=template&id=2087bcd2&scoped=true&"
import script from "./TransferStoreInformation.vue?vue&type=script&lang=js&"
export * from "./TransferStoreInformation.vue?vue&type=script&lang=js&"
import style0 from "./TransferStoreInformation.vue?vue&type=style&index=0&id=2087bcd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2087bcd2",
  null
  
)

export default component.exports